import { j as a } from "../../utils-BdNIfrGQ.js";
import * as f from "react";
import { useState as p, useCallback as d, useEffect as v } from "react";
import { P as x } from "../../index-oiSd2zY3.js";
import { D } from "../../Div-spVpsZsH.js";
import { D as z } from "../../Div.skeleton-DLnqOZrU.js";
import { F as O } from "../../Flex-BA9xHq_p.js";
import { L as $ } from "../../List-L_RxfO5h.js";
import { S as F } from "../../Section-CJZfXZsR.js";
import { G as H } from "../../Grid-DJGISvmf.js";
import { H as N } from "../../Header-rsvbExbw.js";
var l = "AspectRatio", c = f.forwardRef(
  (e, r) => {
    const { ratio: t = 1 / 1, style: s, ...i } = e;
    return /* @__PURE__ */ a.jsx(
      "div",
      {
        style: {
          // ensures inner element is contained
          position: "relative",
          // ensures padding bottom trick maths works
          width: "100%",
          paddingBottom: `${100 / t}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ a.jsx(
          x.div,
          {
            ...i,
            ref: r,
            style: {
              ...s,
              // ensures children expand in ratio
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        )
      }
    );
  }
);
c.displayName = l;
var R = c;
const h = R, w = (e) => /* @__PURE__ */ a.jsx(h, { ...e }), j = () => {
  const [e, r] = p({ width: void 0, height: void 0 }), [t, s] = p(null), i = d((o) => {
    s(o);
  }, []);
  return v(() => {
    if (!t) return;
    const o = new ResizeObserver((m) => {
      for (const n of m)
        r({
          width: n.contentRect.width,
          height: n.contentRect.height
        });
    });
    return o.observe(t), () => {
      o.unobserve(t), o.disconnect();
    };
  }, [t]), { ref: i, dimensions: e };
};
export {
  w as AspectRatio,
  D as Div,
  z as DivSkeleton,
  O as Flex,
  H as Grid,
  N as Header,
  $ as List,
  F as Section,
  j as useResizeObserver
};
